module.exports = __webpack_public_path__ + "img/Bild2.ea6d2d0c.jpg";